import {api} from "./service.js";   
const install={
	// 文章删除
	delArticle(data){
	    return api.post("/admin/article.article/delete",data)
	},
	// 文章添加
	addArticle(data){
	    return api.post("/admin/article.article/add",data)
	},
	// 文章编辑
	editArticle(data){
	    return api.post("/admin/article.article/edit",data)
	},
	// 文章列表
	getArticle(data){
	    return api.get("/admin/article.article/index",data)
	},
	// 轮播图删除
	delBanner(data){
	    return api.post("/admin/banner.banner/delete",data)
	},
	// 轮播图编辑
	editBanner(data){
	    return api.post("/admin/banner.banner/edit",data)
	},
	//轮播图添加
	addBanner(data){
	    return api.post("/admin/banner.banner/add",data)
	},
	// 轮播图列表
	getBanner(data){
	    return api.get("/admin/banner.banner/index",data)
	},
	// 预留点位删除
	reserveDelete(data){
	    return api.post("/admin/reserve/delete",data)
	},
	// 生成特殊占用订单
	createOtherOrder(data){
	    return api.post("/admin/advertise/createOrder",data)
	},
	// 获取选中点位信息
	getAds(data){
	    return api.get("/admin/advertise/getAds",data)
	},
	// 广告投放图片集合
	getAdvertiseIds(data){
	    return api.get("/admin/order/getAdvertiseIds",data)
	},
	// 查看更多广告位
	getMoreAdvertise(data){
	    return api.get("/admin/order/getMoreAdvertise",data)
	},
	// 站点套餐删除
	advertiseGradegroupDel(data){
	    return api.post("/admin/advertiseGradegroup/delete",data)
	},
	// 站点套餐编辑
	advertiseGradegroupEdit(data){
	    return api.post("/admin/advertiseGradegroup/edit",data)
	},
	// 站点套餐添加
	advertiseGradegroupAdd(data){
	    return api.post("/admin/advertiseGradegroup/add",data)
	},
	// 站点套餐列表
	advertiseGradegroup(data){
	    return api.get("/admin/advertiseGradegroup/index",data)
	},
	// 审批流程设置编辑
	approvalEdit(data){
	    return api.post("/admin/approvalConfig/edit",data)
	},
	// 审批流程设置列表
	approvalConfig(data){
	    return api.get("/admin/approvalConfig/index",data)
	},
	// 审批
	approvalOperate(data){
	    return api.post("/admin/Approval/operate",data)
	},
	// 审批列表
	approvalList(data){
	    return api.get("/admin/Approval/index",data)
	},
	// 显示上下画图片
	getPushlish(data){
	    return api.post("/admin/order/getPushlish",data)
	},
	// 首页-点位上刊率
	getPublicRate(data){
	    return api.get("/admin/index/getPublicRate",data)
	},
	// 订单切换点位
	switchAdvertise(data){
	    return api.post("/admin/order/switchAdvertise",data)
	},
	// 修改报备到期时间
	editExpireTime(data){
	    return api.post("/admin/report/editExpireTime",data)
	},
	// 报备审核
	reportAudit(data){
	    return api.post("/admin/report/audit",data)
	},
	// 预留点位列表
	reserveList(data){
	    return api.get("/admin/reserve/index",data)
	},
	// 延长报备
	reportDelay(data){
	    return api.post("/admin/report/delay",data)
	},
	// 后台菜单列表(显示后台菜单)
	getMenu(data){
	    return api.get("/admin/ajax/getMenu",data)
	},
	// 角色授权权限保存
	saveAuthorize(data){
	    return api.post("/admin/system.auth/saveAuthorize",data)
	},
	// 菜单管理列表
	authorizeTree(data){
	    return api.get("/admin/system.auth/authorize",data)
	},
	// 周边删除(存在下级对应删除)
	deletePeriphery(data){
	    return api.post("/admin/Periphery/delete",data)
	},
	// 添加周边信息
	addPeriphery(data){
	    return api.post("/admin/Periphery/add",data)
	},
	// 编辑周边信息
	editPeriphery(data){
	    return api.post("/admin/Periphery/edit",data)
	},
	// 周边树列表信息
	peripheryTree(data){
	    return api.get("/admin/Periphery/tree",data)
	},
	// 首页-即将到期报备列表
	indexReport(data){
	    return api.get("/admin/report/lists",data)
	},
	// 首页-即将到期订单列表
	indexOrder(data){
	    return api.get("/admin/order/lists",data)
	},
	// 首页-统计数据
	calculate(data){
	    return api.get("/admin/index/calculate",data)
	},
	// 解锁
	unlock(data){
	    return api.post("/admin/Order/unlock",data)
	},
	// 设置投放画面
	modifyOrderPut(data){
	    return api.post("/admin/Order/modify_put",data)
	},
	// 订单支付
	modifyOrderPay(data){
	    return api.post("/admin/Order/modify_pay",data)
	},
	// 价审、锁位、
	modifyOrder(data){
	    return api.post("/admin/Order/modify",data)
	},
	// 订单删除
	deleteOrder(data){
	    return api.post("/admin/order/delete",data)
	},
	// 通过报价表生成订单
	createOrder(data){
	    return api.post("/admin/Offer/createOrder",data)
	},
	// 报价记录列表
	offerList(data){
	    return api.get("/admin/offer/index",data)
	}, 	
	// 站点(广告位)删除
	deleteAdvertise(data){
	    return api.post("/admin/advertise/delete",data)
	},
	// 上传图片
	upload(data){
	    return api.post("/admin/ajax/upload",data)
	},
	// 站点(广告位)编辑
	editAdvertise(data){
	    return api.post("/admin/advertise/edit",data)
	},
	// 站点(广告位)详情
	detailAdvertise(data){
	    return api.get("/admin/advertise/detail",data)
	}, 	
	// 站点(广告位)添加
	addAdvertise(data){
	    return api.post("/admin/advertise/add",data)
	},
	// 点位枚举
	advertiseEnum(data){
	    return api.get("/admin/advertise/getAllEnum",data)
	}, 	
	// 站点(广告位)配置信息
	getConfig(data){
	    return api.get("/admin/advertise/getConfig",data)
	}, 	
	// 修改备注
	modifyAdvertise(data){
	    return api.post("/admin/advertise/modify",data)
	},
	// 站点(广告位)列表
	advertiseList(data){
	    return api.get("/admin/advertise/index",data)
	}, 	
	// 订单列表
	orderList(data){
	    return api.get("/admin/order/index",data)
	},
	// 报备编辑
	editReport(data){
	    return api.post("/admin/report/edit",data)
	},
	// 获取报备枚举
	reportEnum(data){
	    return api.get("/admin/Report/getAllEnum",data)
	},
	// 报备添加
	addReport(data){
	    return api.post("/admin/report/add",data)
	},
	// 报备删除/admin/report/delete
	deleteReport(data){
	    return api.get("/admin/report/delete",data)
	},
	// 报备列表
    reportList(data){
        return api.get("/admin/report/index",data)
    },
	// 延长预留
	reserveDelay(data){
	    return api.post("/admin/reserve/delay",data)
	},
	//点位禁用
	advertiseDisable(data){
		return api.get("/admin/Advertise/disable",data)
	},
	//预留占用
	reserveOccupy(data){
		return api.get("/admin/Reserve/lists",data)
	}
	
	
}
export default install;